import type { ReactNode } from 'react';

export function PanelHeader({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return (
    <div className="panel-header">
      <span>{children}</span>
      {right && <span className="panel-header__right">{right}</span>}
    </div>
  );
}
